export const SignInScreenPermissions = {
  SIGN_IN: 1,
  CHANGE_PASSWORD: 2,
  SIGN_UP: 3,
  ADD_PAYMENT_METHOD: 4,
  ADD_CUSTOMER_INFO: 5,
  FORGOT_PASSWORD: 6,
  FORGOT_PASSWORD_EMPLOYEE: 7,
};
